import styled from 'styled-components';
import sizeStandards from '../../size-standards';
import getTypographyConfig from '../../typography-config';
import TitleElement from '../TitleElement';

const TitleWrapper = styled(TitleElement)`
  margin: 8px 0;

  ${({ size, $language }) => {
    const typography = getTypographyConfig($language);

    const getSize = (s, fallback) => {
      if (s === 'LG') return fallback.LG;
      if (s === 'MD') return fallback.MD;
      if (s === 'SM') return fallback.SM;

      return fallback.MD;
    };

    const desktop = {
      LG: sizeStandards.font.XXL,
      MD: sizeStandards.font.XL,
      SM: sizeStandards.font.LG,
    };

    const tablet = {
      LG: sizeStandards.font.XL,
      MD: sizeStandards.font.LG,
      SM: sizeStandards.font.MD,
    };

    const mobile = {
      LG: sizeStandards.font.LG,
      MD: sizeStandards.font.MD,
      SM: sizeStandards.font.SM,
    };

    return `
      font-size: ${getSize(size, desktop) * typography.scale}px;
      line-height: ${typography.lineHeight};
      font-weight: ${typography.fontWeight};
      font-family: ${typography.fontFamily};

      @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
        font-size: ${getSize(size, tablet) * typography.scale}px;
      }

      @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
        font-size: ${getSize(size, mobile) * typography.scale}px;
      }
    `;
  }}
`;

export default TitleWrapper;
